<template>
  <div class="new-main" :key="key">
    <Tree @openDialog="openDialog"></Tree>
    <Right></Right>
    <AddProjectDialog v-model="dialogVisible" :queryData="queryData"></AddProjectDialog>
  </div>
</template>
<script>
import Tree from './tree'
import Right from './right'
import AddProjectDialog from './project/add'
import api from '@/services/api/home/home'
import { mapActions } from 'vuex'
import bus from '@/bus'
export default {
  components: {
    Tree,
    Right,
    AddProjectDialog
  },
  data() {
    return {
      dialogVisible: false,
      queryData: {
        project_depart_id: '',
        project_list_id: ''
      },
      dataset: {},
      key: 1,
    }
  },
  created() {
    this.init()
    bus.$on('sendMessageReal', () => {
      this.key ++
    })
    bus.$on('sendMessageRealOne', () => {
      this.key ++
    })
  },
  destroyed() {
    bus.$off('sendMessageReal')
    bus.$off('sendMessageRealOne')
  },
  methods: {
    ...mapActions('home/home', ['getNumberOfCrossProjects','getPermissionIndex']),
    openDialog(data) {
      this.queryData = JSON.parse(JSON.stringify(data))
      this.dialogVisible = true
    },
    async init() {
      this.getPermissionIndex()
      this.getNumberOfCrossProjects()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/{
  .el-tabs__item.is-active .count-number, .el-tabs__item:hover .count-number {
    color: initial;
  }
  .el-dropdown-link {
    padding: 0;
    height: auto;
  }
  .el-card__body {
    display: flex;
  }
  .projectFolder-top-nav{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(231,232,237,0.6);
    margin: 0 40px;
  }
  .tabs-item{
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    .count-number{
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
    }
    .num {
      background: linear-gradient(225deg, #1998F1 0%, #0D70E8 100%);
      border-radius: 10px;
      font-size: 12px;
      color: #fff;
      padding: 0 7px;
      height: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-left: 4px;
    }
    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      position: relative;
      top: 2px;
    }
  }
}
.new-main{
  height: 0;
  flex: 1;
  display: flex;
  /deep/ {
    .task-badge {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
}
</style>
